<template>
  <div>
    <b-container class="mb-3">
      <b-row>
        <b-col cols="12" md="6" class="d-inline-flex align-items-center">
          <!-- <b-form-checkbox
            id="other-options"
          >
            {{ $t('pricelist.options') }}: {{ $t('pricelist.options2') }}
          </b-form-checkbox> -->
        </b-col>
        <b-col cols="12" md="6" class="d-inline-flex align-items-center mt-3 mt-md-0">
          <span class="ml-md-auto mr-2">{{ $t('pricelist.order_by') }}</span>
          <b-form-select v-model="orderBy" class="orderby-select">
            <option value="lowestPrice">{{ $t('pricelist.lowest_price') }}</option>
            <option value="pharmacyName">{{ $t('pricelist.pharmacy_name') }}</option>
          </b-form-select>
        </b-col>
      </b-row>
    </b-container>

    <b-table
      stacked="md"
      class="price-table"
      :fields="fields"
      :items="items"
    >
      <template v-slot:cell(sentBy)="data">
        <router-link
          :to="{ name: 'pharmacy_sheet', query: {categoryUuid: category}, params: { pharmacyUuid: data.item.pharmacyUuid }}"
        >{{ data.item.pharmacyName }}</router-link>
      </template>
      <template v-slot:cell(quantity)="data">
        <NumericInput
          v-model="data.item.quantity"
          :min="1"
          align="center"
          size="100%"
        />
      </template>
      <template v-slot:cell(add)="data">
        <b-button variant="square-cart" @click="buyProduct(data.item)"></b-button>
      </template>
    </b-table>
  </div>
</template>


<script>
import { mapState } from "vuex";
import NumericInput from "@/components/NumericInput";

export default {
  components: {
    NumericInput,
  },
  props: {
    product: Object,
    category: String,
  },
  data() {
    return {
      orderBy: "",
    };
  },
  computed: {
    ...mapState({
      authenticated: state => state.auth.authenticated,
    }),
    fields() {
      return [
        {
          key: "price",
          label: this.$t("pricelist.price"),
          tdClass: "price",
        },
        {
          key: "sentBy",
          label: this.$t("pricelist.sent_by"),
          tdClass: "pharmacy",
        },
        {
          key: "quantity",
          label: this.$t("pricelist.quantity"),
          class: "reduced-col",
        },
        {
          key: "add",
          label: "",
          class: "reduced-col text-right",
        },
      ];
    },
    items() {
      var items = this.product.public_prices.map(price => {
        return {
          uuid: price.uuid,
          price: this.$formatMoney(
            price.all_included_price,
            price.all_included_price_currency
          ),
          raw_price_object: price,
          pharmacyName: price.manager_public_name,
          pharmacyUuid: price.manager,
          quantity: Number(1),
        };
      });

      // Tengo que ordenar a mano porque la tabla solo me deja ordenar por columnas
      // visibles, y el precio de sistema no lo es
      var compare = null;
      if (this.orderBy == "lowestPrice") {
        compare = this.compareItemsPrice;
      } else if (this.orderBy == "pharmacyName") {
        compare = this.compareItemsOwner;
      }
      if (compare) {
        items.sort(compare);
      }

      return items;
    },
  },
  methods: {
    compareItemsPrice(a, b) {
      return a.raw_price_object.all_included_price - b.raw_price_object.all_included_price;
    },
    compareItemsOwner(a, b) {
      return a.pharmacyName.localeCompare(b.pharmacyName);
    },
    buyProduct(item) {
      if (this.product.can_buy_only_if_has_logged && !this.authenticated) {
        this.mnotify_error({
          text: this.$t("pricelist.error.can_buy_only_if_has_logged"),
        });
      } else {
        var quantity = item.quantity || "1";
        try {
          this.$store
            .dispatch("shoppingcart/ADD_PRODUCT", {
              price: item.raw_price_object,
              quantity: quantity,
              product: this.product,
            })
            .then(
              () => {},
              err => {
                this.$sentry({ capture: err });
                this.mnotify_error({
                  text: this.$t("pricelist.error.buy_product"),
                });
              }
            );
        } catch (err) {
          this.$sentry({ capture: err });
          this.mnotify_error({
            text: this.$t("pricelist.error.buy_product"),
          });
        }
      }
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        pricelist: {
          options: "Other options",
          options2: '(Delivery 2/3 days. Price can be "The best")',
          order_by: "Order by",
          lowest_price: "Lowest Price",
          pharmacy_name: "Pharmacy Name",
          price: "Price",
          sent_by: "Sent by",
          quantity: "Quantity",
          error: {
            buy_product: "Cannot add product to the shopping cart",
            can_buy_only_if_has_logged:
              "You can only buy this product if you are logged in",
          },
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
.orderby-select {
  width: $font-size-medium * 12;
}

.price-table ::v-deep {
  thead {
    color: $text-main-color;
    font-size: $font-size-medium;
    font-weight: bold;
    text-transform: uppercase;
  }

  td {
    vertical-align: middle;
  }

  .price {
    font-weight: bold;
  }

  .pharmacy a {
    color: $text-main-color;
    text-decoration: none;
  }

  .reduced-col {
    width: 10%;

    @include media-breakpoint-down(md) {
      width: 100%;
    }
  }
}
</style>
